import {
  AfterViewInit,
  Component, ContentChild, ElementRef, EventEmitter,
  Input, OnInit, Output, TemplateRef, ViewChild
} from '@angular/core';

@Component({
  selector: 'amdocs-swiper',
  templateUrl: './amdocs-swiper.component.html',
  styleUrls: ['./amdocs-swiper.component.scss']
})

export class AmdocsSwiperComponent implements OnInit, AfterViewInit {

  @ViewChild('swiperEl', { static: true }) swiperElRef: ElementRef;

  @Input() slidePerView = 1;
  @Input() spaceBetween = 50;
  @Input() loopMode = false;
  @Input() items: any[] = [];
  @Input() allowTouchMove: boolean = true;

  @Output() onSwipe: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  @ContentChild('swiperContentItem') swiperContentItem: TemplateRef<ElementRef>;

  public currentItem = 0;

  ngOnInit(): void {
    const swiperEl = this.swiperElRef.nativeElement;
    swiperEl.swiper.activeIndex=0;
  }

 
  ngAfterViewInit(): void {
    const swiperEl = this.swiperElRef.nativeElement;
    if (swiperEl.swiper && swiperEl.swiper.on) {
    swiperEl.swiper.on('swiper', (event: any) => {
      this.onSwipe.emit(event.detail[0]);
      this.setCurrentItem(event.detail[0].activeIndex);
    });

    swiperEl.swiper.on('slideChange', () => {
      const currentIndex = swiperEl.swiper.activeIndex;
      this.onChange.emit(currentIndex);
      this.setCurrentItem(currentIndex);
    });

    // Prevent user sliding (touch/mouse drag)
    if(!this.allowTouchMove){
    swiperEl.swiper.allowTouchMove = false;
      if (swiperEl.swiper.mousewheel) {
        swiperEl.swiper.mousewheel.disable();
      }
    }
   }
  }

  setCurrentItem(index: number): void {
    this.currentItem = (index % this.items.length || this.items.length) - 1;
  }

  public next(): void {
    this.swiperElRef.nativeElement.swiper.slideNext();
  }

  public prev(): void {
    this.swiperElRef.nativeElement.swiper.slidePrev();
  }

  public setIndex(index: number): void {
    this.swiperElRef.nativeElement.swiper.slideTo(index);
  }
}
